import * as React from 'react';

import {FeedbackPageContainer} from 'shells/billing/feedback-page/feedback-page-container';
import {FeedbackPageLayout} from 'shells/billing/feedback-page/feedback-page-layout';

import {useGetCsmInfo} from '../../../sidebar/meet-your-csm/use-get-csm-info';

import {useUpdateChurnInfo} from '../graphql/hooks/use-update-churn-info';

import {ChurnForm} from './churn-form';
import {ChurnPageSubmitted} from './churn-page-submitted';
import {CHURN_FORM_ANIMATION_SRC} from './consts';

export function ChurnPage() {
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const {updateChurnInfo, isLoading, error} = useUpdateChurnInfo();
    const {csmInfo} = useGetCsmInfo();

    // @ts-expect-error
    const handleSubmit = (churnInfo) => {
        return updateChurnInfo(churnInfo).then(() => {
            setIsSubmitted(true);
        });
    };

    return (
        <FeedbackPageContainer>
            {isSubmitted ? (
                <ChurnPageSubmitted csmInfo={csmInfo} />
            ) : (
                <FeedbackPageLayout
                    title='You’ve trimmed the plan, not the potential.'
                    subtitle='Changes have been applied- would you mind giving additional insight into your recent change?'
                    animationSrc={CHURN_FORM_ANIMATION_SRC}
                    formComponent={
                        <ChurnForm onSubmit={handleSubmit} isLoading={isLoading} error={error} />
                    }
                />
            )}
        </FeedbackPageContainer>
    );
}
